<div 
    #actionButtonsContainer 
    [class]="{'hidden': !showElement}"
    class="flex flex-col md:flex-row gap-y-1 justify-end gap-x-2 pointer-events-auto opacity-0" 
>
    
    @for (button of actionButtons().slice().reverse(); track $index) {
    
        <app-button [color]="button.style" (event)="handleActionButton(button)">
            
            <div class="flex items-center gap-x-1">
    
                <span class="uppercase">
                    {{ button.text }}
                </span>
               
                @if(button.buttonType === ButtonType.Url) {
                    <i class="text-current">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="3.5" stroke="currentColor" class="size-3">
                            <path stroke-linecap="round" stroke-linejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
                        </svg>  
                    </i>
                }
    
            </div>
    
        </app-button>
    
    }

</div>